import VI from './vi'

const registrationEN: typeof VI = {
  'registration.registration': 'Register',
}

export default registrationEN
